import { backendFetch } from './apiUtils';

// Raw EPO invoice/document payload by invoice id (Reporting service).
// Hybrid SQL + Blob handling — CABS-3211.
export const getEPOInvoice = async (id) => {
  return await backendFetch({
    url: 'EPO/Invoice',
    method: 'GET',
    params: { id },
    isReporting: true,
  });
};

export const updateEpoStatus = async (loadId, status) => {
  return await backendFetch({
    url: 'EPO/status',
    method: 'PUT',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status, id: loadId }),
    },
  });
};

export const getAdminEpoListLazy = async ({ skip = 0, amount = 10, filter = {}, sortKey, sortDirection }) => {
  return await backendFetch({
    url: 'EPO/adminSearchLazy',
    method: 'POST',
    options: {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        skip,
        amount,
        filter,
        applyFilters: Object.keys(filter).length !== 0,
        sort_by: sortKey,
        sort_order: sortDirection,
      }),
    },
  });
};

// download all files for a given EPO load
export const bulkDownload = async (epoLoadId) => {
  return await backendFetch({
    url: 'EPO/bulkDownload/' + epoLoadId,
    method: 'GET',
    isReporting: true,
    options: {
      onResponse: async (response) => {
        return await response.blob();
      },
    },
  });
};
